import React, { useMemo } from "react";
import './ApplicationCscCardHeader.styles.scss'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typography from '@mui/material/Typography';
import useTranslation from '../../translations/use-translation';

const breadcrumbLinkSx = {
  color: 'primary.main',
  cursor: 'pointer',
  textDecoration: 'none',
};

const separatorIconSx = { color: 'primary.main' };

const getServices = () => {
  try { return JSON.parse(localStorage.getItem('cscServices') || '[]'); }
  catch { return []; }
};

const ApplicationCscCardHeader = () =>{
   const navigate = useNavigate();
   const location = useLocation();
   const translate  = useTranslation();
   const { applicationName } = useParams();

   const serviceCategory = useMemo(() => {
     const name = decodeURIComponent(applicationName || '');
     const svc = getServices().find((s) => s.serviceName === name);
     return svc?.serviceCategory || null;
   }, [applicationName]);
   const backToCscCategoryList = () => {
       navigate(-1)
     }

     const breadcrumbs = [
       <Link key="1"  sx={breadcrumbLinkSx} onClick={()=>{navigate('./')}}>
         {translate('DETAILS')}
       </Link>,
        (location.pathname.includes('/verify-documents') ||  location.pathname.includes('/service-centers') || location.pathname.includes('/place-order')) && (
         <Typography key="2" color="text.primary" sx={breadcrumbLinkSx} onClick={()=>{navigate('./verify-documents')}}>
            {translate('VERIFY_DOCUMENTS')}
         </Typography>
       ),
        (location.pathname.includes('/service-centers') || location.pathname.includes('/place-order')) && (
           <Typography key="2" color="text.primary" sx={breadcrumbLinkSx} onClick={()=>{navigate('./service-centers')}}>
                      {translate('SERVICE_CENTERS')}
           </Typography>
         ),
         ( location.pathname.includes('/place-order')) && (
           <Typography key="2" color="text.primary" sx={breadcrumbLinkSx}>
          {translate('PLACE_ORDER')}
           </Typography>
         )
     ];
   return (
       <div className="csc-list-header">
       <span className="header-back-icon">
         <span className="icon-back" onClick={backToCscCategoryList}><ArrowBackIosNewIcon /></span>
         <span className="header-text">
         <Breadcrumbs  separator={<NavigateNextIcon fontSize="small"  sx={separatorIconSx}/>} aria-label="breadcrumb">
       {breadcrumbs}
     </Breadcrumbs>
            </span>
       </span>
       {serviceCategory && (
         <span className="header-order">{serviceCategory}</span>
       )}
     </div>
   )
}

export default ApplicationCscCardHeader;